// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thememaker_smallScreenSidebar__\\+6AlL {
    display: none;
}

.thememaker_sidebarBackdrop__ZKppI {
    display: none;
}

/* .bigScreenSidebar{
    display: none;
} */

@media screen and (max-width: 768px) {
    .thememaker_smallScreenSidebar__\\+6AlL {
        display: block;
    }

    .thememaker_bigScreenSidebar__FScOe {
        display: none;
    }

    .thememaker_sidebarBackdrop__ZKppI {
        display: block;
        position: fixed;
        inset: 0;
        z-index: 1040;
        width: 100%;
        height: 100%;
        padding: 0;
        border: 0;
        background: rgba(15, 10, 35, 0.48);
        cursor: pointer;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/thememaker/thememaker.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;GAEG;;AAEH;IACI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,QAAQ;QACR,aAAa;QACb,WAAW;QACX,YAAY;QACZ,UAAU;QACV,SAAS;QACT,kCAAkC;QAClC,eAAe;IACnB;AACJ","sourcesContent":[".smallScreenSidebar {\n    display: none;\n}\n\n.sidebarBackdrop {\n    display: none;\n}\n\n/* .bigScreenSidebar{\n    display: none;\n} */\n\n@media screen and (max-width: 768px) {\n    .smallScreenSidebar {\n        display: block;\n    }\n\n    .bigScreenSidebar {\n        display: none;\n    }\n\n    .sidebarBackdrop {\n        display: block;\n        position: fixed;\n        inset: 0;\n        z-index: 1040;\n        width: 100%;\n        height: 100%;\n        padding: 0;\n        border: 0;\n        background: rgba(15, 10, 35, 0.48);\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smallScreenSidebar": `thememaker_smallScreenSidebar__+6AlL`,
	"sidebarBackdrop": `thememaker_sidebarBackdrop__ZKppI`,
	"bigScreenSidebar": `thememaker_bigScreenSidebar__FScOe`
};
export default ___CSS_LOADER_EXPORT___;
